import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import GameLevelGranularity from "../components/hiddenSpace/GameLevelGranularity";
import PointLevelGranularity from "../components/hiddenSpace/PointLevelGranularity";
import { PlayerStatsProvider } from "../contexts/PlayerStatsContext";

export default function HiddenSpaceGamePage() {
  const { gameID } = useParams<{ gameID: string }>();
  const [tab, setTab] = useState(0);

  const { data: gameData, isLoading: loadingGame } = useQuery<any>({
    queryKey: ["game", gameID],
    enabled: !!gameID,
    queryFn: async () => {
      const url = `https://www.backend.ufastats.com/api/v1/games?gameIDs=${encodeURIComponent(
        gameID || "",
      )}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`games fetch failed: ${res.status}`);
      const json = await res.json();
      // api may return data array or single object
      const d = json.data || json;
      if (Array.isArray(d)) return d[0] || null;
      return d || null;
    },
  });

  const homeTeamID = gameData?.homeTeamID;
  const awayTeamID = gameData?.awayTeamID;

  if (loadingGame) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Loading game data...
        </Typography>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <PlayerStatsProvider homeTeamId={homeTeamID} awayTeamId={awayTeamID}>
        <Typography variant="h6">Game: {gameID}</Typography>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)}>
            <Tab label="Game Level" />
            <Tab label="Point Level" />
          </Tabs>
        </Box>
        <Box sx={{ mt: 2 }}>
          {tab === 0 && <GameLevelGranularity gameID={gameID!} />}
          {tab === 1 && homeTeamID && awayTeamID && (
            <PointLevelGranularity
              gameID={gameID!}
              homeTeamId={homeTeamID!}
              awayTeamId={awayTeamID!}
            />
          )}
        </Box>
      </PlayerStatsProvider>
    </div>
  );
}
